import React, { useContext } from 'react';
import { NavBarItemWithSubMenu } from './nav-bar-item-with-sub-menu';
import { useHeaderData } from '../../hooks/use-header-data';
import { HeaderStateContext } from '../../context/header-state-context';
import { NavBarItem } from './nav-bar-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavBar = function NavBar() {
  var headerData = useHeaderData();

  var _useContext = useContext(HeaderStateContext),
      resetNavBarState = _useContext.resetNavBarState;

  if (!headerData) {
    return null;
  }

  return /*#__PURE__*/_jsxs("ul", {
    role: "menu",
    className: "d-none d-xl-flex px-300 p-xl-0 my-xl-n200 gap-300",
    onMouseLeave: resetNavBarState,
    children: [/*#__PURE__*/_jsx(NavBarItemWithSubMenu, {
      item: headerData.productNavigation,
      numberOfItemsPerColumn: 5,
      showWhatsNew: true
    }), /*#__PURE__*/_jsx(NavBarItemWithSubMenu, {
      item: headerData.solutionsNavigation,
      numberOfItemsPerColumn: 7
    }), /*#__PURE__*/_jsx(NavBarItemWithSubMenu, {
      item: headerData.resourcesNavigation,
      numberOfItemsPerColumn: 7
    }), /*#__PURE__*/_jsx(NavBarItemWithSubMenu, {
      item: headerData.enterpriseNavigation,
      numberOfItemsPerColumn: 7
    }), /*#__PURE__*/_jsx(NavBarItem, {
      item: headerData.pricingLink
    })]
  });
};